import { createModel } from "nyax";
import { Device, DeviceQuery } from "src/models/device";
import { DeviceEntityModel } from "src/store/models/entity/device/entity";
import { DeviceSideUIModel } from "src/store/models/ui/device/deviceSide";
import { createUITableWithPermissionModel } from "src/store/models/ui/_shared";

export type DeviceWithPermission = Device & {
  permissionValues: string[];
};

export const DeviceTableUIModel = createModel(
  class extends createUITableWithPermissionModel<Device, DeviceQuery>({
    setItems: (getContainer, items) =>
      getContainer(DeviceEntityModel).actions.setItems.dispatch(items),
    getItems: (getContainer) => getContainer(DeviceEntityModel).getters.items,
    getItem: (getContainer, id) =>
      getContainer(DeviceEntityModel).state.byId[id],
    getItemId: (item) => item.id,
  }) {
    public effects() {
      const superEffects = super.effects();
      return {
        ...superEffects,
        updateQuery: async (params: DeviceQuery) => {
          await superEffects.updateQuery(params);
          await this.getContainer(DeviceSideUIModel).actions.setQuery.dispatch(
            this.state.query
          );
        },
        initial: async (payload: { departmentId: string }) => {
          const { departmentId } = payload;
          this._initial({
            initialAction: (
              pageIndex: number,
              pageSize: number,
              query: DeviceQuery
            ) =>
              this.dependencies.serviceClient.device.list(
                departmentId,
                pageIndex,
                pageSize,
                query
              ),
          });
        },
      };
    }
  }
);
